let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lU1wr"), load("29wqP"), load("dVstB"), load("3vBXj"), load("70aiP"), load("8oWxD"), load("jzQ6f")]).then(() => parcelRequire('ylKHA'));